import React from 'react';
import { phoneRegex } from '../index';
// styles
import { telephoneAnchorLink } from './CustomHelpersStyles';

export interface TelephoneAnchorProps {
  children: string;
  isSmallScreen: boolean;
  href: string;
}

function TelephoneAnchor({
  children,
  isSmallScreen,
  href
}: TelephoneAnchorProps) {
  if (
    (href.indexOf('tel:') === 0 ||
      phoneRegex.test(children[0]?.replace(/\s/g, ''))) &&
    !isSmallScreen
  ) {
    return <span>{children}</span>;
  }

  return (
    <a href={href} style={telephoneAnchorLink}>
      {children}
    </a>
  );
}

export default TelephoneAnchor;
